import React, { useState, useEffect, Fragment, useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../store/rootStore";
import { ICard } from "../models/card";
import { ISubject } from "../models/subject";

interface IProps {
  card?: ICard;
  subject: ISubject;
  subjectIndex: number;
  formIndex: number;
}

const Card:React.FC<IProps> = observer(({card, subject, subjectIndex, formIndex}) => {

  const rootStore = useContext(RootStoreContext);
  const {setCardChosen, resetCards} = rootStore.cardsStore;

  const [backgroundImage, setBackgroundImage] = useState();
  const [backgroundOverlay, setBackgroundOverlay] = useState();
  const [backgroundClass, setBackgroundClass] = useState('');
  const imageCardOffsets = [3,1,0,4,1,2];

  const shortSummary = (content: string|null) => {
    const wordSplit = 35;
    if(content === null || content.length < 50) return "";
    const splitArray = content.split(' ');
    if(splitArray.length < wordSplit) return content;
    return splitArray.slice(0, wordSplit).join(' ') + "...";
  }

  useEffect(() => {
    
    const imageFormPosition = imageCardOffsets[subjectIndex % imageCardOffsets.length];

    // Mod it by the highest position in imageCardOffsets 
    if((formIndex % 5) === imageFormPosition) {
      if(subject.subjectImage.image) {
        setBackgroundOverlay({backgroundImage: `linear-gradient(0deg, rgba(24, 101, 208, ${subject.subjectImage.overlayOpacity}), rgba(24, 101, 208, ${subject.subjectImage.overlayOpacity}))`});
        setBackgroundImage({backgroundImage: `url(${subject.subjectImage.image.node.mediaItemUrl})`});
        setBackgroundClass('has-background');
      }
    }  
  }, [formIndex, subject]);

  const cardClicked = (e, card) => {
    e.preventDefault();
    resetCards();
    setCardChosen(card);
  }

  return (
    <Fragment>
      {card &&
        <div className={`the-wall__card_inner ${backgroundClass}`}>
          <div className='the-wall__background-image' style={backgroundImage} />
          <div className='the-wall__background-image-overlay'  style={backgroundOverlay} />          
          <h2 onClick={(e) => cardClicked(e, card)}>{card.subjectTitle} {card.cardDetails.level}</h2>
          <div className='the-wall__card-body' dangerouslySetInnerHTML={{__html: (card.content)}} />
          <a href='#' onClick={(e) => cardClicked(e, card)}>Read more <i className="fa-light fa-circle-plus"></i></a>
        </div>
      }
      {!card &&
        <div className={`the-wall__card_inner ${backgroundClass}`}>
          <div className='the-wall__background-image' style={backgroundImage} />
          <div className='the-wall__background-image-overlay' style={backgroundOverlay} />

        </div>
      }
    </Fragment>
  )
});

export default Card;
